import { api } from '../Api';
import { requirePortalAccess, sessionRequest } from '../PortalSession';
import { validateEventPage } from './contract';

export const getDispatcherEvents = ({ cursor, signal }) => {
  requirePortalAccess();
  return sessionRequest(async (requestSignal) => validateEventPage(await api.get(
    '/deliveryops/alert-events',
    { mode: cursor ? 'live' : 'baseline', limit: 100, ...(cursor ? { cursor } : {}) },
    { cache: 'no-store', signal: requestSignal }
  )), signal);
};
